import m from "mithril";
export const getDistUrl = (path) => `${window["CDN_URL"]}/${window["PUBLIC_PATH"]}${path}`;
export const getAsset = (file) => getDistUrl(`assets/${file}`);
const breakpoints = [[0, "mobile-xxs"], [550, "mobile-xs"], [650, "mobile-s"], [768, "mobile-m"], [1024, "tablet"], [1200, "desktop"]].reverse();
export const findDevice = (w = window.innerWidth) => (breakpoints.find(x => w >= x[0]));
let device = findDevice();
if (window.on) {
    window.on("resize", () => {
        const d = findDevice();
        if (device[0] === d[0])
            return;
        device = d;
        m.redraw();
    });
}
export const isDevice = (...d) => d.some(x => device[1].startsWith(x));
export const getDevice = () => ({
    width: device[0],
    device: device[1],
});
let _cache = {};
export const cache = (key, fn) => _cache[key] ??= fn();
export const handleSnap = (value, snap, threshold = snap?.threshold ?? 0) => {
    let _snap;
    if (snap) {
        const target = snap.targets.reduce((s, x) => {
            const sv = x.value;
            const distance = Math.abs(value - sv);
            if (distance <= threshold && (!s || distance < s.distance))
                return { distance, snap: x };
            return s;
        }, undefined);
        if (target)
            _snap = {
                ...target.snap,
                distance: target.distance,
            };
    }
    return _snap;
};
export const formatCurrency = (value) => `€${!value ? "0,00" : value.toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
